import React, { Component } from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import { ChatService } from '../../services/chat';
import './chat.css';

export default class Chat extends Component {
  constructor(props) {
    super(props);

    this.getAllMessages = this.getAllMessages.bind(this);

    this.state = {
      "messages": null,
      "count": null,
      "input_value": "",
      "user": null
    }
  }

  componentWillMount() {
    this.getAllMessages()
    this.getUserDetails()
    this.dispatchMessagesInterval()
  }

  async getUserDetails() {
    // var user = await UsersService.getUserDetails();
    var user = await Sdk.Api.dynamic.bridge(`/auth/v1.0/user/me`, null, 'GET');
    this.setState({
      "user": user
    });
  }

  async getAllMessages() {
    // var user = await UsersService.getUserDetails();
    var user = await Sdk.Api.dynamic.bridge(`/auth/v1.0/user/me`, null, 'GET');
    var messages = await ChatService.getAllMessages(this.props.context, this.props.contextUid);
    var messagesList = messages.messages;
    for (var i = 0; i < messagesList.length; i++) {
      messagesList[i].owner = messagesList[i].user_uid === user.uid ? "me" : "another"
    }

    this.setState({
      "messages": messagesList,
      "count": messages.count
    })
  }

  dispatchMessagesInterval() {
    var _this = this;
    window.interval = setInterval(_this.getAllMessages, 1000);
  }

  async sendMessage() {
    var context = this.props.context;
    var contextUid = this.props.contextUid;
    var userUid = this.state.user.uid;
    var userName = this.state.user.detail.name;
    var message = this.state.input_value;

    this.setState({
      "input_value": ""
    })
    await ChatService.post(context, contextUid, userUid, userName, message)
    this.getAllMessages()
  }

  formatAvatar(userName) {
    var slug = "";

    var divided = userName.split(" ");
    slug += divided[0].charAt(0);

    if (divided.length === 2) {
      slug += divided[1].charAt(0);
    };

    slug = slug.toUpperCase();

    return slug;
  }

  onBack() {
    clearInterval(window.interval);
    this.props.onBack();
  }

  render() {
    const {
      messages,
      input_value
    } = this.state;
    return (
      <div className="rdp-react-template-component-chat">
        <div className="rdp-react-template-component-chat-header">
          <button className="rdp-react-template-component-chat-header-btn" onClick={() => this.onBack()}></button>
          <span className="rdp-react-template-component-chat-header-title">{this.props.title || "Chat"}</span>
        </div>
        {messages === null &&
          <div className="rdp-react-template-component-chat-preloader">
            <div className="rdp-react-template-component-chat-preloader-loader"></div>
          </div>
        }

        {messages !== null && messages.length === 0 &&
          <div className="rdp-react-template-component-chat-no-messages">
            <span className="rdp-react-template-component-chat-no-messages-icon"></span>
            <p className="rdp-react-template-component-chat-no-messages-label">Nenhuma mensagem encontrada neste chat.</p>
          </div>
        }

        {messages !== null && messages.length > 0 &&
          <ul className="rdp-react-template-component-chat-messages">
            {messages.map(message => {
              return <li className={`rdp-react-template-component-chat-message ${message.owner}`}>
                {/* <span className="rdp-react-template-component-chat-message-avatar" style={{backgroundImage: `url(${message.thumb})`}}></span> */}
                <span className="rdp-react-template-component-chat-message-avatar-label">{this.formatAvatar(message.user_name)}</span>
                <div className="rdp-react-template-component-chat-message-message">
                  <span className="rdp-react-template-component-chat-message-author">{message.user_name}</span>
                  <p>{message.message}</p>                
                </div>
              </li>
            })}
          </ul>
        }
        <div className="rdp-react-template-component-chat-actions">
          <input className="rdp-react-template-component-chat-action-input" value={input_value} type="text" onChange={(e) => {
            this.setState({
              "input_value": e.target.value
            })
          }}/>
          <button className="rdp-react-template-component-chat-action-send-btn" onClick={() => this.sendMessage()}></button>
        </div>
      </div>
    );
  }
}
